import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Popover, Radio } from 'antd'
import { IconClose } from '@edulastic/icons'
import { withNamespaces } from '@edulastic/localization'
import { themeColorsMap_NY_3_8_State } from '../../../../theme'
import { setSelectedThemeAction } from '../../../../student/Sidebar/ducks'
import {
  StyleColorChoiceHeaderTitle,
  StyledColorChoiceHeader,
  StyledColorChoiceRadioContentWrapper,
  StyledColorChoiceRadioGroup,
  StyledColorChoiceSwatch,
  StyledColorChoiceTitleWrapper,
} from './styled'

const ChangeColor = ({
  visible,
  handleVisibleChange,
  selectedTheme,
  setSelectedTheme,
  t: i18Translate,
  children,
}) => {
  const handleThemeChange = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setSelectedTheme(e.target.value)
  }

  const content = (
    <StyledColorChoiceRadioGroup
      dataCy="colorChoicesPopoverContent"
      onChange={handleThemeChange}
      value={selectedTheme}
    >
      {Object.keys(themeColorsMap_NY_3_8_State).map((key) => {
        const item = themeColorsMap_NY_3_8_State[key]
        const titles = i18Translate(
          `testOptions.questerColorContrastOptions.${key}`
        ).split('\n')

        return (
          <Radio dataCy={`${item.title}`} key={key} value={item.key || key}>
            <StyledColorChoiceRadioContentWrapper>
              <StyledColorChoiceSwatch
                background={item.themeColor}
                color={item.themeSecondaryColor}
              >
                {i18Translate(
                  `testOptions.questerColorContrastOptions.swatchText`
                )}
              </StyledColorChoiceSwatch>
              <StyledColorChoiceTitleWrapper multiLine={titles.length > 1}>
                {titles.map((text) => (
                  <span>{text.trim()}</span>
                ))}
              </StyledColorChoiceTitleWrapper>
            </StyledColorChoiceRadioContentWrapper>
          </Radio>
        )
      })}
    </StyledColorChoiceRadioGroup>
  )

  const header = (
    <StyledColorChoiceHeader>
      <StyleColorChoiceHeaderTitle>
        {i18Translate('header:toolbar.changeColor')}
      </StyleColorChoiceHeaderTitle>
      <IconClose
        style={{ cursor: 'pointer', fill: 'white' }}
        onClick={() => handleVisibleChange(false)}
      />
    </StyledColorChoiceHeader>
  )

  return (
    <Popover
      dataCy="colorChoicesPopover"
      content={content}
      title={header}
      trigger={['click']}
      visible={visible}
      onVisibleChange={handleVisibleChange}
      placement="bottom"
      overlayStyle={{ width: 'auto' }}
      destroyTooltipOnHide={false}
    >
      {children}
    </Popover>
  )
}

const enhance = compose(
  withNamespaces(['header', 'student']),
  connect(
    (state) => ({
      selectedTheme: state.ui.selectedTheme || 'default',
    }),
    {
      setSelectedTheme: setSelectedThemeAction,
    }
  )
)

export default enhance(ChangeColor)
